// extracted by mini-css-extract-plugin
module.exports = {"player":"style_player__55f7y","containerPlayers":"style_containerPlayers__1jhO6","spanError":"style_spanError__26Ezi","animaError":"style_animaError__hz38i"};